import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  setIsChatModalOpen,
  setIsParticipantsModalOpen,
} from '../../store/actions';
import MicButton from './MicButton';
import CameraButton from './CameraButton';
import SwitchToScreenSharingButton from './SwitchToScreenSharingButton';
import RecordMeeting from './RecordMeeting';
import LeaveRoomButton from './LeaveRoomButton';

const VideoButtons = ({
  isChatOpen,
  setIsChatModalOpen,
  isParticipantsOpen,
  setIsParticipantsModalOpen,
  showRecording,
  roomId,
  meetingStream,
  participants,
  identity,
}) => {
  const history = useHistory();

  return (
    <div className="video_buttons_container">
      <MicButton />
      <CameraButton />
      <SwitchToScreenSharingButton />

      {showRecording && (
        <RecordMeeting roomId={roomId} remoteStreams={meetingStream} participants={participants} identity={identity} />
      )}

      <div
        className="video_button_container"
        onClick={() => setIsChatModalOpen(!isChatOpen)}
      >
        <div className="video_button_icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
        <span className="video_button_label">Chat</span>
      </div>

      <div
        className="video_button_container"
        onClick={() => setIsParticipantsModalOpen(!isParticipantsOpen)}
      >
        <div className="video_button_icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <span className="video_button_label">People</span>
      </div>

      <LeaveRoomButton history={history} />
    </div>
  );
};

const mapStoreStateToProps = ({ room }) => {
  return {
    ...room,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsChatModalOpen: (isChatOpen) => dispatch(setIsChatModalOpen(isChatOpen)),
    setIsParticipantsModalOpen: (isParticipantsOpen) => dispatch(setIsParticipantsModalOpen(isParticipantsOpen)),
  };
};

export default connect(mapStoreStateToProps, mapDispatchToProps)(VideoButtons);
